import { useEffect, useState } from 'react';

import { isWeb } from 'utils/responsiveness';

type Props = {
    id: string;
    textFieldFocused: boolean;
};

function useTriggerLabelAnimationOnAutofill({ id, textFieldFocused }: Props) {
    const [isAutofill, setAutofill] = useState(false);

    useEffect(() => {
        if (isWeb) {
            const searchAutofill = setTimeout(() => {
                const textInput = document.getElementById(id);

                if (textInput && textInput.matches(':autofill')) {
                    setAutofill(!textFieldFocused);
                }
            }, 400);

            return () => clearTimeout(searchAutofill);
        }
    }, [textFieldFocused, id]);

    return {
        isAutofill,
    };
}

export default useTriggerLabelAnimationOnAutofill;
